import React from 'react';

const MediaHeader = ({ image, alt, tag, compact = false }) => {
    const heightClass = compact ? 'h-48 md:h-64' : 'h-64 md:h-80';
    return (
        <div className={`relative overflow-hidden rounded-t-[1.75rem] ${heightClass}`}>
            <img
                src={image}
                alt={alt}
                className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/60 via-slate-950/20 to-transparent" />
            {tag ? (
                <div className="absolute bottom-4 left-4 right-4">
                    <span className="inline-flex rounded-full bg-white/20 px-4 py-2 text-xs font-semibold uppercase tracking-[0.22em] text-white backdrop-blur-sm">
                        {tag}
                    </span>
                </div>
            ) : null}
        </div>
    );
};

export default MediaHeader;
